import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const badgeFn = /* @__PURE__ */ createRecipe('badge', {
  "size": "md",
  "variant": "solid",
  "shape": "pill"
}, [
  {
    "shape": "rounded",
    "size": "sm",
    "css": {
      "px": "1"
    }
  },
  {
    "shape": "rounded",
    "size": "md",
    "css": {
      "px": "1.5"
    }
  },
  {
    "shape": "rounded",
    "size": "lg",
    "css": {
      "px": "2",
      "& svg": {
        "marginInlineStart": "-0.5"
      }
    }
  }
])

const badgeVariantMap = {
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "variant": [
    "solid",
    "subtle",
    "outline"
  ],
  "shape": [
    "pill",
    "rounded"
  ]
}

const badgeVariantKeys = Object.keys(badgeVariantMap)

export const badge = /* @__PURE__ */ Object.assign(memo(badgeFn.recipeFn), {
  __recipe__: true,
  __name__: 'badge',
  __getCompoundVariantCss__: badgeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: badgeVariantKeys,
  variantMap: badgeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, badgeVariantKeys)
  },
  getVariantProps: badgeFn.getVariantProps,
})